import React from "react";
import { data } from "../assets/strategies";

import './TagsButtons.css'
const TagsButtons = ({ filterItem, setItem, tagItems }) => {

  return (
    <div className="marketing-tags-wrapper">
      <button className="modal-content-tag" onClick={() => setItem(data)}>
        All
      </button>

      {tagItems.map((Val, id) => {
        return (
          <button className="modal-content-tag" onClick={() => filterItem(Val)} key={id}>
            {Val}
          </button>
        );
      })}
    </div>
  );
};

export default TagsButtons;
